import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'ramda';

import { Container, Text, SourceText, Thumbnail } from './testimonial.styles';
import { renderWhenNotNil } from '../../../../shared/utils/rendering';
import { EntityRefData } from '../../../../shared/components/entityRefData';

export class TestimonialComponent extends PureComponent {
  static propTypes = {
    text: PropTypes.string,
    sourceLink: PropTypes.string,
    sourceText: PropTypes.string,
    thumbnail: PropTypes.string,
    className: PropTypes.string,
  };

  renderIcon = renderWhenNotNil(iconRef => (
    <EntityRefData id={iconRef}>{({ file }) => <Thumbnail src={file.url} />}</EntityRefData>
  ));

  renderSource = (text, link) => {
    const linkProps = link ? { as: 'a', href: link, target: '_blank' } : {};
    return <SourceText {...linkProps}>{text}</SourceText>;
  };

  render() {
    return (
      <Container className={this.props.className}>
        <Text>{this.props.text}</Text>
        {this.renderIcon(this.props.thumbnail)}
        {this.renderSource(this.props.sourceText, this.props.sourceLink)}
      </Container>
    );
  }
}

export const Testimonial = compose(injectIntl)(TestimonialComponent);
